import { Search, Filter, LayoutGrid } from 'lucide-react';
import './styles/Department.css';

const DepartmentToolbar = () => {
  return (
    <div className="department-toolbar">
      <div className="department-search">
        <Search className="department-search-icon" />

        <input type="text" placeholder="Search Departments" className="department-search-input" />
      </div>

      <div className="department-toolbar-actions">
        <button className="filter-btn">
          <Filter />
          <span>Filter</span>
        </button>

        <button className="grid-btn">
          <LayoutGrid />
        </button>
      </div>
    </div>
  );
};

export default DepartmentToolbar;
